import { createRequest, ValidationError } from '@shared/services';

type MemberProfileErrorFields = {
    [key in keyof MemberProfilePayload]: string;
};

export type MemberProfileErrors = {
    errors: MemberProfileErrorFields;
};

export async function getMemberProfile() {
    const request = createRequest<MemberProfileResponse>({
        url: '/member/profile',
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function putMemberProfile(payload: MemberProfilePayload) {
    let result: MemberProfileResponse | null = null;
    let errors: MemberProfileErrorFields | null = null;

    try {
        const request = createRequest<MemberProfileResponse>({
            url: '/member/profile',
            method: 'PUT',
            data: payload,
            withAuthorization: true,
        });

        result = await request.execute();
    } catch (error) {
        if (error instanceof ValidationError) {
            const details = error.context.detail;

            errors = {} as MemberProfileErrorFields;

            if (Array.isArray(details)) {
                for (let i = 0; i < details.length; i++) {
                    const errorField = details[i];
                    const [, field] = errorField.loc;

                    errors[field] = errorField.msg;
                }
            }
        }
    }

    if (errors) {
        return { errors } as MemberProfileErrors;
    }

    return result;
}
